namespace $ {

	/** Scope the acknowledgement to one exact signed invitation and Gift. */
	export class $shm_hitalama_map_access_delivery_request extends $mol_object {

		static body( fields: readonly unknown[] ) { return 'hitalama-map-delivery:v1\n' + JSON.stringify( fields ) }

		@ $mol_mem_key
		static signed( [ auth, map, catalog, recipient, self, hash, grant_time, time ]:
			readonly [ $giper_baza_auth, string, string, string, string, string, number, number ] ) {
			const fields = [ 1, map, catalog, recipient, self, hash, grant_time, time, auth.pass().toString() ]
			const bytes = this.$.$mol_wire_sync( this.$ ).$mol_charset_encode( this.body( fields ) )
			const signature = this.$.$mol_wire_sync( auth.signer() ).sign( bytes )
			return JSON.stringify([ ...fields, this.$.$mol_base64_url_encode( signature ) ])
		}

		@ $mol_mem_key
		static parse( raw: string ) {
			if( raw.length > 2048 ) return null
			return this.$.$mol_error_fence( ()=> {
				const value = JSON.parse( raw )
				if( !Array.isArray( value ) || value.length !== 10 ) return null
				const [ version, map, catalog, recipient, self, hash, grant_time, time, pub, signature ] = value
				if( version !== 1 ) return null
				for( const id of [ map, catalog, recipient ] ) {
					if( typeof id !== 'string' || !/^[a-zA-ZæÆ0-9]{8}_[a-zA-ZæÆ0-9]{8}$/.test( id ) ) return null
				}
				if( typeof self !== 'string' || !/^[a-zA-ZæÆ0-9]{8}$/.test( self ) ) return null
				if( typeof hash !== 'string' || !/^[a-zA-ZæÆ0-9]{8}_[a-zA-ZæÆ0-9]{8}$/.test( hash ) ) return null
				if( !Number.isSafeInteger( grant_time ) || grant_time <= 0 || !Number.isSafeInteger( time ) || time <= 0 ) return null
				if( typeof pub !== 'string' || !/^[a-zA-Z0-9_-]{86}$/.test( pub ) ) return null
				if( typeof signature !== 'string' || !/^[a-zA-Z0-9_-]{86}$/.test( signature ) ) return null
				const pass = this.$.$giper_baza_auth_pass.from( pub )
				if( pass.uint8( 0 ) !== 0xFF ) return null
				return { map, catalog, recipient, self, hash, grant_time, time, pass,
					body: this.$.$mol_charset_encode( this.body( value.slice( 0, 9 ) ) ),
					signature: this.$.$mol_base64_url_decode( signature ),
				}
			}, ()=> null )
		}

		@ $mol_action
		static verify( raw: string, now: number ) {
			const request = this.parse( raw )
			if( !request || Math.abs( now - request.time ) > 5 * 60_000 ) return null
			return this.$.$mol_wire_sync( request.pass.auditor() ).verify( request.body, request.signature ) ? request : null
		}

	}

}
